import cloud_error_code_pb from "@skydio/pbtypes/pbtypes/gen/cloud_api/cloud_error_code_pb";

import * as alerts_v2 from "./alerts_v2";
import * as auth from "./auth";
import * as dataFiles from "./data_files";
import * as featureFlags from "./feature_flags";
import * as fileKinds from "./file_kinds";
import * as flights from "./flights";
import * as groups from "./groups";
import * as organizations from "./organizations";
import * as pagination from "./pagination";
import * as releases from "./releases";
import * as devReleases from "./dev_releases";
import * as controllerReleases from "./controller_releases";
import * as controllerDevReleases from "./controller_dev_releases";
import * as stats from "./stats";
import * as uconUploadConfig from "./ucon_upload_config";
import * as users from "./users";
import * as vehicles from "./vehicles";
import type { ValueType } from "@skydio/core";

export const modules = {
  alerts_v2,
  auth,
  dataFiles,
  featureFlags,
  fileKinds,
  flights,
  groups,
  organizations,
  pagination,
  releases,
  devReleases,
  controllerReleases,
  controllerDevReleases,
  stats,
  uconUploadConfig,
  users,
  vehicles,
};

export { default as endpoints } from "./endpoints";
export { sendRequest, sendRequestPreserveKeys, sendRequestPreserveAllKeys } from "./requests-browser";
export const ErrorCode = cloud_error_code_pb.CloudErrorCode.Enum;
export type ErrorCode = ValueType<cloud_error_code_pb.CloudErrorCode.EnumMap>;

export * from "./auth/types";
export * from "./data_files/types";
export * from "./feature_flags/types";
export * from "./flights/types";
export * from "./groups/types";
export * from "./organizations/types";
export * from "./pagination/types";
export * from "./releases/types";
export * from "./dev_releases/types";
export * from "./controller_releases/types";
export * from "./controller_dev_releases/types";
export * from "./stats/types";
export * from "./ucon_upload_config/types";
export * from "./users/types";
export * from "./vehicles/types";
export * from "./onprem_admin/types";
